import cn from 'classnames/bind'

import { BaseItem, RenderItem } from './types'
import styles from './default-render-item.module.scss'

const cx = cn.bind(styles)

export const defaultRenderItem = <T extends BaseItem>(...args: Parameters<RenderItem<T>>) => {
  const [item, { active, selected, itemHeight }] = args

  return (
    <span
      title={item.title}
      className={cx(styles.root, { active, selected })}
      style={{ height: `${itemHeight}px` }}
    >
      {item.title}
    </span>
  )
}
